import { Component, Input, OnInit, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { Request, Http } from '@angular/http';

import { AuthService } from '../../services/auth.service';
// import { FooterDirective } from '../../directives/footer.directive';
// import { FooterItem }      from '../footer/footer-item';
// import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'layout-footer',
  template: `<div><ng-template sn-footer></ng-template></div>`
})
export class FooterLoaderComponent implements OnInit, OnDestroy {
  // @Input() footers: FooterItem[];
  // @ViewChild(FooterDirective) footerContainer: FooterDirective;

  constructor(
      private componentFactoryResolver: ComponentFactoryResolver,
      private authService: AuthService
    ) { }

  ngOnInit() {
    this.loadComponent();
  }

  ngOnDestroy() {
  }

  loadComponent() {
  }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/footer/footer-loader.component.ts